import { render, staticRenderFns } from "./OperacoesDeAdministradores.vue?vue&type=template&id=5449353a&scoped=true"
import script from "./OperacoesDeAdministradores.vue?vue&type=script&lang=js"
export * from "./OperacoesDeAdministradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5449353a",
  null
  
)

export default component.exports